import './homepage.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import React, { useEffect, useState } from 'react';

import { Divider, Modal } from 'antd';

import Nav from '../../utils/nav';
import Footer from '../../utils/footer';
import InstagramFeed from 'react-ig-feed';
import Slider from "react-slick";

import { Controller, useForm } from 'react-hook-form';

import { Input, Drawer, Spin } from 'antd';

import _1 from '../../assets/images/homepage/_1.jpg';

import HeroVideo from '../../assets/videos/hero.mp4';

import Showcase1 from '../../assets/images/homepage/prop5.jpg';
import Showcase2 from '../../assets/images/homepage/prop6.jpg';
import Showcase3 from '../../assets/images/homepage/prop7.png';
import Showcase4 from '../../assets/images/homepage/prop8.png';
import showcase5 from '../../assets/images/content/showcase5.webp';
import showcase6 from '../../assets/images/content/showcase6.webp';

import Mail from '../../assets/images/icons/mail.svg';

import showcase7 from '../../assets/images/homepage/prop1.jpg';
import showcase8 from '../../assets/images/homepage/prop2.jpg';
import showcase9 from '../../assets/images/homepage/prop3.jpg';
import showcase10 from '../../assets/images/homepage/prop4.jpg';

import bombas1 from '../../assets/images/homepage/prop8.jpg';
import bombas2 from '../../assets/images/homepage/prop7.jpg';
import bombas3 from '../../assets/images/homepage/prop6.jpg';
import bombas4 from '../../assets/images/homepage/prop5.jpg';


import testimonial from '../../assets/images/content/testimonial.webp';
// import testimonial from '../../assets/images/products/torera.png';

import packager from '../../assets/images/homepage/delivery.png';
import lorry from '../../assets/images/homepage/furnitures.png';
import tree from '../../assets/images/homepage/chair.png';
import { Link } from 'react-router-dom';


const Homepage = () => {
    let token = "IGQVJWbFFlVkZARMUxQc1BqZAWxoeVQwM0M2NEhKQmtmOHZADaDZA2OTRJM2JHZAmg2SVhrNUgyQ3VaOVBCZA1ByRG1kc0VIYVd1djFRLXNfTWNaeWFoeTVxUUZAJRmsyTXhuSTBBNDMxbFFHdkYzd3NfRVJhbwZDZD";
    const [isModalVisible, setIsModalVisible] = useState(false);

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        setIsModalVisible(false);
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };
    const { handleSubmit, control } = useForm({});
    useEffect(() => {
        setTimeout(() => {
            setIsModalVisible(true)
        }, 8000)
    }, [])

    let settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        centerPadding: '30px',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: false,
                    dots: false,
                    centerMode: true,
                    focusOnSelect: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 1,
                    centerMode: true,
                    focusOnSelect: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    focusOnSelect: true
                }
            }
        ]
    }
    return (
        <div className="homepage-display">
            <Nav />
            <div className="header">
                <div>
                    <h3>Vo3 Designs</h3>
                    <p>Extending your indoors-outdoors</p>
                    <Link to="/products/Chairs">Shop Seating</Link>
                </div>
            </div>
            <div>
                <div className="header_product_list mt_5">
                    <div className="contain">
                        <div className="main_top">
                            <h3
                                style={{ textAlign: 'center' }}
                                className="check-header">Clever designs, delivered free</h3>
                            <div className="grid_4">
                                <div>
                                    <img src={Showcase1} alt="showcase1" />
                                    <h4>Seating</h4>
                                </div>
                                <div>
                                    <img src={Showcase2} alt="showcase1" />
                                    <h4>Seating</h4>
                                </div>
                                <div>
                                    <img src={Showcase3} alt="showcase1" />
                                    <h4>Seating</h4>
                                </div>
                                <div>
                                    <img src={Showcase4} alt="showcase1" />
                                    <h4>Seating</h4>
                                </div>
                            </div>
                        </div>
                        {/* <div className="mobile inner-contain">
                            <Slider {...settings}>
                                <div key={1}>
                                    <img src={Showcase1} alt="showcase1" />
                                </div>
                                <div key={2}>
                                    <img src={Showcase2} alt="showcase1" />
                                </div>
                                <div key={3}>
                                    <img src={Showcase3} alt="showcase1" />
                                </div>
                                <div key={4}>
                                    <img src={Showcase4} alt="showcase1" />
                                </div>
                            </Slider>
                        </div> */}
                    </div>
                </div>
                <div className="story_props mt_5">
                    <div className="grid_2">
                        <div>
                            <div className="contain">
                                <h3>Explore each unique collection</h3>
                                <div className="grid_2">
                                    <div>
                                        <div className="">
                                            <img src={lorry} alt="tree" />
                                            <div>
                                                <h4>Uniquely designed items</h4>
                                                <p>Each Vo3 item is remarkable designed and manufactured at the highest production standards</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="">
                                            <img src={lorry} alt="tree" />
                                            <div>
                                                <h4>Space-saving solutions</h4>
                                                <p>Our items are intentionally created to maximise and make the best use of our users' spaces</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="">
                                            <img src={packager} alt="tree" />
                                            <div>
                                                <h4>Bespoke design services</h4>
                                                <p>Haven't seen exactly what you're looking for? Feel free to contact us for your custom furniture and design needs.</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="deskto">
                                        <div className="">
                                            <img src={tree} alt="tree" />
                                            <div>
                                                <h4>Sustainable Furniture</h4>
                                                <p>Every Vo3 product is manufactured keeping eco-friendliness in mind</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="video_banner">
                            <video loop playsinline="" autoPlay muted preload="auto">
                                {/* "https://media.graphassets.com/okjMYiS3eRh9cULy7cDg" */}
                                <source type="video/mp4" src={HeroVideo} />

                            </video>
                        </div>
                    </div>
                </div>
                <div className="shop-shortcut mt_5">
                    <div className="contain">
                        <div>
                            <h3 className="check-header">Explore our uniquely designed furniture.</h3>
                        </div>
                        <div>
                        <div className="desktop">
                            <div className="grid_4">
                                <div>
                                    <Link to="/products/Tables">
                                        <img src={showcase7} alt="showcase1" />
                                        <h4>Seating</h4>
                                    </Link>
                                </div>
                                <div>
                                    <Link to="/products/Benches">
                                        <img src={showcase8} alt="showcase1" />
                                        <h4>Seating</h4>
                                    </Link>
                                </div>
                                <div>
                                    <Link to="/products/Consoles">
                                        <img src={showcase9} alt="showcase1" />
                                        <h4>Seating</h4>
                                    </Link>
                                </div>
                                <div>
                                    <Link to="/products/Chairs">
                                        <img src={showcase10} alt="showcase1" />
                                        <h4>Seating</h4>
                                    </Link>
                                </div>
                            </div>
                            </div>
                            <div className="mobile inner-contain">
                                <Slider {...settings}>
                                    <div key={1}>
                                        <img src={showcase7} alt="showcase1" />
                                    </div>
                                    <div key={2}>
                                        <img src={showcase8} alt="showcase1" />
                                    </div>
                                    <div key={3}>
                                        <img src={showcase9} alt="showcase1" />
                                    </div>
                                    <div key={4}>
                                        <img src={showcase10} alt="showcase1" />
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="contain mt_5">
                    <h3>Our Social Media Presence.</h3>
                    <InstagramFeed token={token} counter="6" />
                </div> */}
                <div className="testimonials mt_5">
                    <div className="grid_2">
                        <div className="grid_text_div">
                            <div className="grid_text_cover">
                                <h5>LOVED BY PEOPLE LIKE YOU</h5>
                                <h4>I'm really big on making the best use of my space, and this table is the perfect fit for me.</h4>
                                <p>Dr Joy Aifou, Satisfied Customer</p>
                            </div>
                        </div>
                        <div>
                            <div className="testimonial_image_div">
                                {/* <img src={testimonial} */}
                                <img src={testimonial}
                                    style={{ width: 'auto', height: 'auto' }}
                                    alt="testimonial" className="testimonial_image" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            <Modal
                footer={null}
                title={null} visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
                <div className="notifs_modal">
                    <div className="grid_">
                        <div>
                            <div className="notifs_data">
                                <img src={Mail} alt="subscribe to our newsletter" />
                                <h3>Like deals, discounts and updates on our Furniture?</h3>
                                <p>Enter your email and we’d send them your way</p>
                                <div>
                                    <div className="form_group">
                                        {/* <label>Password</label> */}
                                        <Controller name="firstName" control={control}
                                            render={({ field }) => (
                                                <Input placeholder="example.gmail.com"
                                                    style={{ height: '3rem' }}
                                                    {...field} name="firstName" />
                                            )} />
                                        <button>Subscribe</button>
                                    </div>
                                </div>
                                <div>
                                    <p className="unimportant">
                                        Your privacy is important to us, so we'll never spam you or share your info with
                                        third parties. Take a look at our privacy policy. You can also unsubscribe at any time.
                                    </p>
                                </div>
                            </div>
                        </div>
                        {/* <div>
                            <img src={_1} alt="_1" />
                        </div> */}
                    </div>
                </div>
            </Modal>
            <Drawer
                // style={{ display: 'block' }}
                title={'Hello'} placement="right"
                // onClose={onClose}
                open={true}>
                {/* <Spin spinning={spinnerLoading}> */}
                <div>
                    <div>
                        <h2>Hello dude</h2>
                    </div>
                </div>
                {/* </Spin> */}
            </Drawer>
        </div>
    )
}

export default Homepage;